module.exports = __webpack_public_path__ + "static/media/fiverr-logo.af5272c9.png";